import type { WeeklyAction } from "~vue/pages/developmentJourneys/weeklyActions";
import { DateTime } from "luxon";

// A yyyy-MM-dd key in the user's zone, for comparing against week boundaries - not for display.
export const localDate = (timestamp: string, timezone: string): string => DateTime.fromISO(timestamp, { zone: timezone }).toISODate() ?? "";

export const actionIsCommitted = (action: WeeklyAction, end: string, timezone: string): boolean => action.committed_at !== null && localDate(action.committed_at, timezone) <= end;

export const actionIsCompleted = (action: WeeklyAction, end: string, timezone: string): boolean =>
    action.status === "completed" && localDate(action.status_changed_at, timezone) <= end;

export const weekStart = (date: string): string => {
    const value = new Date(`${date}T00:00:00Z`);
    value.setUTCDate(value.getUTCDate() - ((value.getUTCDay() + 6) % 7));
    return value.toISOString().slice(0, 10);
};

export const shiftDate = (date: string, days: number): string => {
    const value = new Date(`${date}T00:00:00Z`);
    value.setUTCDate(value.getUTCDate() + days);
    return value.toISOString().slice(0, 10);
};
